import {Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import { DOCUMENT } from '@angular/common'; 


import {AuthenticationService, BaseComponent, Message} from 'iui-iconectiv-lib';
import {AccountCompletionService} from './account-completion.service';
import {SummaryService} from '../summary';
import {Account} from '../shared/model/account.model'

@Component({
  selector: 'app-account-completion',
  templateUrl: './account-completion.component.html',
  styleUrls: ['./account-completion.component.scss'],
})
export class AccountCompletionComponent extends BaseComponent implements OnInit {

  @ViewChild('accountForm', {static: true}) accountForm;

  
  // my account
  myAccount: Account;

  // show account completion modal, and obtain user's completion data
  showAccountCompletion = false;
  tierConfirmed: boolean = false;

  sameAsAccount: boolean = false;

  ACCOUNT_TYPE_STANDARD = Account.ACCOUNT_TYPE_STANDARD.value;
  ACCOUNT_TYPE_NON_STANDARD = Account.ACCOUNT_TYPE_NON_STANDARD.value;

  constructor(private accountCompletionService: AccountCompletionService,
              private authService: AuthenticationService,
              private router: Router,
              private summaryService: SummaryService,
              @Inject(DOCUMENT) document) {

    super();
  }


  /**
   * retrieve account information from session storage
   */
  ngOnInit() {
    this.myAccount = this.summaryService.getFinderAccount() as Account;

    if (this.myAccount != null) {
      this.log.debug(`from storage: myAccount=${JSON.stringify(this.myAccount)}`);
      this.log.debug(`accountId=${this.myAccount.accountId}`);

      // display UI for user to complete the account
      this.showAccountCompletion = true;
    } else {
      this.myAccount = new Account();
      this.log.error(`failed to retrieve account data from storage for username=${this.authService.username()}`);
      this.displayError();
    }
  }

  // billing info set same as contact info
  sameAsAccountInfo(event) {
    this.sameAsAccount = event.checked;

    // if user wants billing same as contact information
    if(event.checked == true) {
      this.myAccount.billingFirstName = this.myAccount.firstName;
      this.myAccount.billingLastName = this.myAccount.lastName;
      this.myAccount.billingEmail = this.myAccount.email;
      this.myAccount.billingPhone = this.myAccount.phone;
      this.myAccount.billingCountry = this.myAccount.country;
      this.myAccount.billingAddress1 = this.myAccount.address1;
      this.myAccount.billingAddress2 = this.myAccount.address2;
      this.myAccount.billingCity = this.myAccount.city;
      this.myAccount.billingState = this.myAccount.state;
      this.myAccount.billingZipCode = this.myAccount.zipCode;
    }
  }

  /**
   * Save finalized account
   */
  saveMyAccount() {
    this.log.debug(`saveMyAccount(): myAccount=${JSON.stringify(this.myAccount)}`);
    this.clearMessages();

    if (!this.hasDigitsAndLetters(this.myAccount.spid, 4)) {
      this.displayErrorMessage(new Message('Error', 'The SPID must be 4 characters.'));
      return false;
    }
    
    // this._renderer.setProperty(this.accountDialogId.nativeElement, 'scrollTop', this.accountDialogId.nativeElement.scrollHeight);
    // save the finalized account
    this.accountCompletionService.putAccountCompletion(JSON.stringify(this.myAccount)).subscribe(
      res => {
        this.log.debug(`saveMyAccount(): result message=${JSON.stringify(res['messages'])}`);
        if (res['status'] === 'fail') {
          // failed to save the finalized account
          const message: any = res['messages'][0];
          const errorMessage = message['message'];
          this.log.error(`failed to save the finalized account: ${errorMessage}`);
          this.displayErrorMessage(errorMessage);
          
          var errorDivs =document.getElementById('errorDiv');
          errorDivs.scrollIntoView();
        } else {
          // successfully save the finalized account, navigate to /search page
          this.router.navigate(['/search']);
        }
      },
      error => {
        this.log.error(`failed to save the finalized account: got HttpError=${JSON.stringify(error)}`);
        this.displayError();
      }
    );
  }


  /**
   * log user out
   */
  logmeout() {
    const extras: NavigationExtras = {
      queryParams: {'dologout': true},
      queryParamsHandling: ''
    };
    this.router.navigate(['/sec/login'], extras);
  }


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

  isFormValid() {
    var validForm = this.accountForm.valid;
    var validStandardTier = this.myAccount.accountType === this.ACCOUNT_TYPE_STANDARD && this.myAccount.tier;
    var validCustomTier = this.myAccount.accountType === this.ACCOUNT_TYPE_NON_STANDARD && this.tierConfirmed;
    return validForm && (validStandardTier || validCustomTier);
  }

  hasDigitsAndLetters(string: string, n: number): boolean {

    if (string === null || string === '') {
      return true;
    } else { //non(alphanumeric + _ )
      return string.replace(/[\W_]/g, '').length === n;
    }
  }

}
